import React from 'react';

import { Box, DropdownMenu, IconButton } from '@betterment/samba-react';

const IntegrationMenu: React.FC<{
  onDisconnect: () => void;
}> = ({ onDisconnect }) => {
  return (
    <Box>
      <DropdownMenu>
        <DropdownMenu.Trigger asChild={true}>
          <IconButton label="Show options" name="Ellipses" spacing="none" />
        </DropdownMenu.Trigger>
        <DropdownMenu.Content align="center" side="bottom">
          <DropdownMenu.Item css={{ color: 'text.critical' }} onSelect={onDisconnect}>
            Disconnect
          </DropdownMenu.Item>
        </DropdownMenu.Content>
      </DropdownMenu>
    </Box>
  );
};

export default IntegrationMenu;
